import React from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import Login from './auth/Login';
import AuthenticatedRoute from './auth/AuthenticatedRoute';
import Layout from './Layout';

const Main = ({authLoading}) => {
    if (authLoading) {
        return null;
    }
    return (
        <Switch>
            <Route path="/login"><Login /></Route>
            <AuthenticatedRoute component={Layout} />
        </Switch>
    );
};

const mapStateToProps = (state) => {
    return {
        authLoading: state.auth.firstLoading,
    };
};

export default connect(mapStateToProps)(Main);

